import { render, staticRenderFns } from "./CardSplit.vue?vue&type=template&id=6de9c98b&"
import script from "./CardSplit.vue?vue&type=script&lang=js&"
export * from "./CardSplit.vue?vue&type=script&lang=js&"
import style0 from "./CardSplit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports